  (<template>
  <div class="list" id="souvenir-list">
    <h1 v-translate>Souvenirs</h1>
    <div class="create-button-container">
      <el-button v-if="$session.exists() && $route.path !=='/'"
                 id="button-add-souvenir"
                 type="primary"
                 icon="el-icon-plus"
                 @click="$router.push('/souvenirs/create')"></el-button>
    </div>
    <div v-if="souvenirList.length > 0">
      <el-table v-if="souvenirList"
                id="souvenir-table"
                :data="souvenirListPage"
                height="100%">
        <el-table-column class="souvenir-table-column">
          <template slot-scope="souvenir">
            <div class="souvenir-list-flex-container">
              <div class="souvenir-list-thumbnail">
                <img :src="souvenir.row.thumbnailUrl"/>
              </div>
              <div class="souvenir-list-content">
                  <strong><translate>Name</translate>:</strong>&nbsp;
                  {{souvenir.row.name}}<br/>
                   <strong><translate>Description</translate>:</strong>&nbsp;
                  {{souvenir.row.description}}<br/>
                   <strong><translate>Price</translate>:</strong>&nbsp;
                  {{souvenir.row.price}} RON
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="souvenir">
            <el-button v-if="$session.exists() && $route.path !=='/'"
                       id="button-edit"
                       icon="el-icon-edit"
                       @click="edit(souvenir.row.id)"></el-button>
            <el-button v-if="$session.exists() && $route.path !=='/'"
                       id="button-delete"
                       type="danger" icon="el-icon-delete"
                       @click="remove(souvenir.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <el-pagination background
                     layout="prev, pager, next"
                     :total="souvenirList.length"
                     :current-page.sync="currentPage"
                     :page-size="pageSize"
                     @current-change="changePage">
      </el-pagination>
      <el-dialog v-if="$session.exists() && isEditVisible"
                 :before-close="handleClose"
                 :visible.sync="isEditVisible">
        <souvenir-upload-form :loaded-form="souvenir"
                              @close-edit="closeEdit"
                              preview></souvenir-upload-form>
      </el-dialog>
    </div>
  </div>
</template>)

(<script>
import axios from 'axios'
import SouvenirUploadForm from './Souvenir-Create-Update-Form.vue'

export default {
  name: 'souvenir-list',
  data () {
    var menuItems = {
      images: 'images'
    }
    return {
      menuItems,
      activeMenuImagesOrMap: menuItems.images,
      isEditVisible: false,
      monumentId: null,
      monument: null,
      souvenirList: [],
      currentPage: 1,
      pageSize: 10,
      souvenirListPage: []
    }
  },
  created () {
    this.getSouvenirList()
  },
  components: {
    'souvenir-upload-form': SouvenirUploadForm
  },
  methods: {
    changePage () {
      this.souvenirListPage = this.souvenirList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    getSouvenirList () {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/souvenirs?lang=${this.$language.current}`,
        withCredentials: true
      })
      .then(response => {
        this.souvenirList = response.data
        this.souvenirListPage = this.souvenirList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    getSouvenir (id, callback) {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/souvenirs/${id}`,
        withCredentials: true
      })
      .then(response => {
        this.souvenir = response.data
        callback(null)
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
        callback(error)
      })
    },
    handleClose (done) {
      this.$confirm(this.$gettext('Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(() => {
        done()
      }).catch(() => {})
    },
    edit (id) {
      this.getSouvenir(id, error => {
        if (!error) {
          this.isEditVisible = true
        }
      })
    },
    closeEdit () {
      this.isEditVisible = false
      this.getSouvenirList()
    },
    remove (id) {
      this.$confirm(this.$gettext('Are you sure to delete the souvenir?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(() => {
        axios({
          method: 'delete',
          url: `${process.env.SERVER_URL}/souvenirs/${id}`,
          withCredentials: true
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$gettext('Delete has completed')
          })
          this.getSouvenirList()
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$gettext('Delete has canceled')
        })
      })
    }
  }
}
</script>)

(<style>
#souvenir-table {
  height: 45em;
  overflow: hidden;
}
.el-table__body-wrapper {
  overflow-x: hidden;
}
.create-button-container {
  text-align: right;
}
.el-table td div {
  height: 0%;
}
.souvenir-list-flex-container {
  height: 7em;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
}
.souvenir-list-content {
  margin: auto;
  width: 60%;
  text-align: center;
}
.souvenir-list-thumbnail {
  width: 40%;
  margin: auto;
  height: 80%;
  text-align: center;
}
.souvenir-list-thumbnail > img {
  height: 100%;
  max-width: 150px;
}
.preview {
  padding: 5%;
  padding-top: 1%;
  text-align: left;
  max-height: 40em;
  overflow-y: scroll;
  scroll-behavior: smooth;
  line-height: 1em;
}
@media screen and (max-width: 1300px) {
  .souvenir-list-flex-container {
    flex-direction: column;
    height: 10em;
  }
  .souvenir-list-thumbnail {
    height: 60%;
  }
}
</style>)



// WEBPACK FOOTER //
// src/components/Souvenir-List-View.vue